import { render } from "./agent_create_page.vue?vue&type=template&id=0f30afaf"
import script from "./agent_create_page.vue?vue&type=script&lang=js"
export * from "./agent_create_page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__